import { useState } from "react";
import { Library } from "lucide-react";

/**
 * Marca de la aplicación: el símbolo de KidsIQ, servido local desde
 * web/public/assets/kidsiq-symbol.png. Es un logotipo a color y autocontenido,
 * así que va directo sobre el fondo (sin el recuadro azul que tenía el ícono).
 * Si la imagen falla, cae al ícono de biblioteca para que nada se vea roto.
 */
export function AppMark({ size = 44, className }: { size?: number; className?: string }) {
  const [falla, setFalla] = useState(false);
  if (falla) {
    return (
      <span
        className={className}
        style={{ display: "inline-grid", placeItems: "center", width: size, height: size }}
      >
        <Library aria-hidden size={Math.round(size * 0.58)} />
      </span>
    );
  }
  return (
    <img
      src="/assets/kidsiq-symbol.png"
      alt="KidsIQ"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: "contain", display: "block" }}
      onError={() => setFalla(true)}
    />
  );
}
